import {
  GET_PICKLIST,
  GET_PICKLIST_ERROR,
  GET_PICKLIST_SUCCESS,
} from "../modules/picklist/actions/picklistActions";
import AuthFetch from "../auth/AuthFetch";
import type { Middleware } from "@reduxjs/toolkit";

const apiEndpoint = `${import.meta.env.API_ENDPOINT}/api/picklist`;

const picklistApi: Middleware = (store) => (next) => (action) => {
  next(action);
  switch (action.type) {
    case GET_PICKLIST: {
      AuthFetch(fetch, apiEndpoint, { method: "get" })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            return next({
              type: GET_PICKLIST_ERROR,
              payload: {
                data: response.status + " " + response.statusText,
              },
            });
          }
        })
        .then((data) => {
          return next({
            type: GET_PICKLIST_SUCCESS,
            payload: {
              data: data,
            },
          });
        })
        .catch((err) => {
          return next({
            type: GET_PICKLIST_ERROR,
            payload: {
              data: err,
            },
          });
        });
      break;
    }
    default:
      return store;
  }
};

export default picklistApi;
